export const Options = () => {
  return (
    <svg
      width="11"
      height="17"
      viewBox="0 0 11 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="5.5"
        cy="13.5"
        r="1.5"
        transform="rotate(-90 5.5 13.5)"
        fill="#535F70"
      />
      <circle
        cx="5.5"
        cy="8.5"
        r="1.5"
        transform="rotate(-90 5.5 8.5)"
        fill="#535F70"
      />
      <circle
        cx="5.5"
        cy="3.5"
        r="1.5"
        transform="rotate(-90 5.5 3.5)"
        fill="#535F70"
      />
    </svg>
  );
};
